import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import GoogleMap from "../../components/ui/GoogleMap/GoogleMap";
import { useLocationContext } from "../../context/LocationContext";
import storeService from "../../services/storeService";
import BackButton from "../../components/ui/Header/BackButton";
import { getGroupsedStores } from "../../utils";




// Carl to obviously refine this later
const MapPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { coords } = useLocationContext();
    const [available, setAvailable] = useState([]);
    const [unavailable, setUnavailable] = useState([]);
    const [showAvailableOnly, setShowAvailableOnly] = useState(false);


    const [activeStore, setActiveStore] = useState(null);
    useEffect(() => {
        if (!coords) {
            navigate("/location");
            return;


        }
        const init = async () => {
            const data = await storeService.getNearbyStores(coords.latitude, coords.longitude, 1);
            let storesArray = [];
            if (data && typeof data === 'object') {
                // If API returns paginated response
                if (data.data && Array.isArray(data.data)) {
                    storesArray = data.data;
                }
            } else if (Array.isArray(data)) {
                storesArray = data;
            }

            const {
                urgent,
                now,
                soon,
                unavailable
            } = getGroupsedStores([...storesArray]);

            setAvailable([...urgent, ...now, ...soon])
            setUnavailable(unavailable)

            if (location.state?.storeId) {
                const match = storesArray.find(
                    (s) => s.public_id === location.state.storeId
                );
                if (match) setActiveStore(match.public_id);
            }
        }


        init();
        return () => {
            setShowAvailableOnly(false)
        };
    }, [])

    if (!coords) {
        return (
            <></>
        )

    }
    return (
        <div className="flex flex-col items-center justify-start min-h-screen min-w-screen">
            {!activeStore &&
                <div className="fixed top-0 right-0 z-50">
                    <div className="flex items-center px-4 py-3">
                        <a
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowAvailableOnly(prev => !prev)
                            }}
                            className="bg-gg-dark px-2 py-1 shadow-md rounded text-white font-gg-medium text-sm cursor-pointer"
                        >
                            {showAvailableOnly ? "Show All" : "Show Available Today"}
                        </a>
                    </div>
                </div>
            }
            <GoogleMap
                // We want user at center of map
                center={{ lat: coords.latitude, lng: coords.longitude }}
                locationsArray={

                    (showAvailableOnly ?
                        available :
                        [...available, ...unavailable]
                    ).map(s => ({
                        ...s,
                        lat: parseFloat(s.latitude),
                        lng: parseFloat(s.longitude),
                        id: s.
                            public_id
                        ,
                        hasProducts: unavailable.find(u => u.public_id === s.public_id) ? false : true
                    }))}
                activeStore={activeStore}
                setActiveStore={setActiveStore}
            />
        </div>

    )

};

export default MapPage;